import React from "react";
import { Tooltip } from "@/components/common/Tooltip";

interface AccessItemProps {
  primaryText: string;
  tooltipText?: string;
  permissionLabel?: string | React.ReactNode;
  canRevokeAccess?: boolean;
  isCurrentUser?: boolean;
  isPending?: boolean;
  isActive?: boolean;
  className?: string;
  children?: React.ReactNode;
  controls?: React.ReactNode;
}

export const AccessItem: React.FC<AccessItemProps> = ({
  primaryText,
  tooltipText,
  permissionLabel,
  canRevokeAccess = false,
  isCurrentUser = false,
  isPending = false,
  className,
  children,
  controls,
}) => {
  const rowClassName = className ?? "rounded-app hover:bg-list-hover pl-2";
  const content = (
    <span
      className={`truncate block ${isPending ? "text-fg-muted-medium italic" : "text-fg-regular"}`}
    >
      {primaryText}
    </span>
  );

  const permissionContent =
    !permissionLabel && !canRevokeAccess && !controls ? null : (
      <div className="flex items-center shrink-0">
        {typeof permissionLabel === "string" ? (
          <span className="text-fg-muted-regular">{permissionLabel}</span>
        ) : (
          permissionLabel
        )}
        {controls}
      </div>
    );

  return (
    <div className="group">
      <div
        className={`cursor-default item-height flex items-center gap-2 w-full ${rowClassName}`.trim()}
      >
        <div className="flex items-center gap-2 flex-1 min-w-0">
          {tooltipText ? (
            <Tooltip title={tooltipText} placement="bottom-start">
              {content}
            </Tooltip>
          ) : (
            content
          )}
          {isCurrentUser && (
            <span className="text-fg-semibold shrink-0">(You)</span>
          )}
        </div>

        {permissionContent && (
          <div className="text-fg-muted-regular flex items-center ml-auto shrink-0 ">
            {permissionContent}
          </div>
        )}

        {children}
      </div>
    </div>
  );
};
